import { IStyle } from '@fluentui/react';

export interface IFeatureSetTransformationStyles {
  root?: IStyle;
  fields?: IStyle;
  fileUploadContainer?: IStyle;
  fileUploadContainerHeader?: IStyle;
}

export interface IFeatureSetTransformationClassNames {
  root: string;
  fields: string;
  fileUploadContainer: string;
  fileUploadContainerHeader: string;
}

export const featureSetTransformationStylesDefault: Partial<IFeatureSetTransformationStyles> = {
  root: {},
  fields: {},
  fileUploadContainer: {
    position: 'relative',
    marginTop: '16px',
    marginBottom: '-30px',
  },
  fileUploadContainerHeader: {
    position: 'absolute',
    top: '20px',
    width: '100%',
    textAlign: 'center',
  },
};
